<template>
  <v-navigation-drawer
    app
    v-model="drawer"
    :mini-variant="mini && !isMobile && !hover"
    :temporary="mini && hover"
    @mouseover.native="hover=true"
    @mouseleave.native="hover=false"
    mobile-break-point="960"
    width="230"
  >
    <v-toolbar flat class="transparent">
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <img :src="user.attributes.picture || 'http://profilepicturesdp.com/wp-content/uploads/2018/06/blank-profile-picture-google.jpg'">
          </v-list-tile-avatar>

          <v-list-tile-content class="px-2">
            <v-list-tile-title class="username">{{ user.username }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-list class="pt-0" dense>
      <v-divider></v-divider>
      <v-list-tile
        @click="mini=true;hover=false;drawer=true"
        class="list-item"
        v-for="item in singleItems"
        :key="item.title"
        :to="item.path"
      >
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>

        <v-list-tile-content class="px-2">
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-list class="pt-0 bottom-menu" dense>
      <v-list-tile @click="mini=true;hover=false;drawer=true" class="list-item" key="setting" :to="'/setting'">
        <v-list-tile-action>
          <v-icon>settings</v-icon>
        </v-list-tile-action>

        <v-list-tile-content class="px-2">
          <v-list-tile-title>Setting</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="mini=true;hover=false;drawer=true" class="list-item" key="logout" :to="'/logout'">
        <v-list-tile-action>
          <v-icon>logout</v-icon>
        </v-list-tile-action>

        <v-list-tile-content class="px-2">
          <v-list-tile-title>Logout</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    user: {
      username: {
        type: String
      },
      attributes: {
        picture: {
          type: String
        }
      }
    },
    drawerProp: {
      type: Boolean
    },
    menuItems: {
      type: Array
    }
  },
  data() {
    return {
      drawer: this.drawerProp,
      mini: true,
      hover: false
    };
  },
  watch: {
    drawer: {
      handler: function(value) {
        this.$emit("toggleDrawer", value);
      },
      immediate: true
    },
    drawerProp: {
      handler: function(value) {
        this.drawer = value;
      },
      immediate: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 960
    },
    singleItems() {
      return this.menuItems.filter(item => !item.children);
    }
  }
};
</script>
<style scoped>
.username {
  font-size: 17px;
}

.nav-child-item > a {
  padding-left: 48px;
}

.v-navigation-drawer .v-list__tile__action,
.v-toolbar__content .v-list__tile__avatar { 
  justify-content: center;
}

.bottom-menu {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.list-item .v-list__tile__title {
  font-size: 20px;
  line-height: 20px;
}

.list-item:hover {
  background-color: var(--v-accent-base);
}
</style>
